import { useGetHeadquarterLogisticOperatorsQuery } from '../services';
import { PaginatedRequest } from '@/types';

interface UseGetHeadquartersOperatorsProps {
  paginated: PaginatedRequest;
}

const useGetHeadquartersOperators = ({
  paginated,
}: UseGetHeadquartersOperatorsProps) => {
  const { data: paginatedResponse, isLoading } =
    useGetHeadquarterLogisticOperatorsQuery({ paginated });

  const headquarters = paginatedResponse?.items || [];

  return {
    headquarters,
    isLoading,
  };
};

export default useGetHeadquartersOperators;
